import { render } from "./AppSettings.vue?vue&type=template&id=4656ce8c"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/dqlm/crypt/proj/eaxlabs_svn/fvemon/trunk/src/uiwww/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__